<template>
  <section>
    <div class="container">
      <!-- 工具列表 -->
      <div class="tool-name">AI Agent</div>
      <div class="tool-list">
        <div v-for="item in agents" :key="item.name" class="tool-item" @click="clickAgent(item)">
          <img :src="item.avatar" alt="">
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
let page_name="library"
import {getListSelect} from "@/api/temple.js"
export default {
  name: "library",
  data() {
    return {
      agents:[
        {
          avatar:'https://cdn.cxc-group.com/static/IMG_202512307495_644x644%20%281%29.png',
          name:'文档助理',
          url:'https://yuanqi.tencent.com/webim/#/chat/NoCkNr?appid=2005843120904505600&experience=true&space_id=spXFdt4E3iTwwVB1GeikzaQNFYfWMUTc'
        },
        {
          avatar:'https://cdn.cxc-group.com/static/IMG_202512302445_644x644%20%281%29.png',
          name:'释小缘',
          url:'https://yuanqi.tencent.com/webim/#/chat/eqTwul?appid=2005818710432017408&experience=true&space_id=spXFdt4E3iTwwVB1GeikzaQNFYfWMUTc'
        },
      ]
    };
  },

  mounted(){
    
  },

  methods: {
    // 点击工具列表项
    clickAgent(item){
      // 因为是第三方界面 而且有微信登陆环节 不能用iframe
      // 所以用window.open打开新窗口
      window.open(item.url, '_blank')
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/static/default";

.container {
  background-color: #fff !important;
  padding: 0 32px;
  overflow-y:overlay;
  box-sizing: border-box;
  padding: 20px;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 100%;
}
.tool-name{
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}
.tool-list{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  border-radius: 10px;
  border-right: 1px solid #e5e5e5;
  .tool-item{
    width: 200px;
    height: 60px;
    display: flex;
    box-sizing: border-box;
    padding: 0 20px;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 10px;
    margin-bottom: 10px;
    transition: all 0.3s ease-in-out;
    margin-right: 20px;

    &:hover{
      background-color: #e5e5e5;
    }
    
    cursor: pointer;
    img{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
    p{
      font-size: 16px;
      margin-left:10px;
      color: #333;
    }
  }
}

</style>